import React from "react";

const Contact = () => {
    return (<div>
        <h1>Contact</h1>
        <p>blis@hey.com</p>
        <p><a href="https://bsky.app/profile/b1is.bsky.social">Bluesky </a></p>
        <p><a href="https://www.linkedin.com/in/lisbernard/">Linkedin </a></p>
    </div>);
};

export default Contact;
